import React, { useRef, useState, useEffect } from 'react';
import Confetti from 'react-confetti';

import { Flex } from '@chakra-ui/react';

const ConfettiEffect: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  const [display, setDisplay] = useState(true);

  useEffect(() => {
    const updateDimensions = (): void => {
      if (containerRef.current) {
        setWidth(containerRef.current.clientWidth);
        setHeight(containerRef.current.clientHeight);
        return;
      }

      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => window.removeEventListener('resize', updateDimensions);
  }, []);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDisplay(false);
    }, 5000);

    return () => clearTimeout(timeout);
  }, []);

  if (!display) {
    return null;
  }

  return (
    <Flex
      ref={containerRef}
      position="fixed"
      width="100vw"
      height="100vh"
      top="0"
      bottom="0"
      right="0"
      left="0"
      overflow="hidden"
      zIndex="9999"
    >
      <Confetti
        width={width}
        height={height}
        numberOfPieces={400}
        recycle={false}
        tweenDuration={5000}
      />
    </Flex>
  );
};

export default ConfettiEffect;
